import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Box,
} from '@mui/material';
import {
  ContactMail as ContactMailIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Badge as BadgeIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationOnIcon,
  Notes as NotesIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store';
import { ModificarContacto } from '../../../actions/ClientesAction';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';

const PerfilContactos = (props) => {
  const mounted = useRef(true);
  const contactop = props.location.state;
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [id, setId] = useState('');
  const [contacto, setContacto] = useState({
    NOMBRE: '',
    APELLIDO: '',
    TELEFONO: '',
    DIRECCION: '',
    EMAIL: '',
    USUARIO: '',
    OBSERVACIONES: '',
  });
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setContacto((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const EditarContacto = () => {
    const usuario = sesionUsuario.usuario.nombrecompleto;
    const objetoNuevo = {
      NOMBRE: contacto.NOMBRE,
      APELLIDO: contacto.APELLIDO,
      TELEFONO: contacto.TELEFONO,
      DIRECCION: contacto.DIRECCION,
      EMAIL: contacto.EMAIL,
      OBSERVACIONES: contacto.OBSERVACIONES,
      USUARIO: usuario,
    };
    ModificarContacto(objetoNuevo, id).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se modifico con exito el contacto',
          },
        });
        setContacto({
          NOMBRE: '',
          APELLIDO: '',
          TELEFONO: '',
          DIRECCION: '',
          EMAIL: '',
          USUARIO: '',
          OBSERVACIONES: '',
        });
        let objetoAudi = {
          usuario: sesionUsuario.usuario.nombrecompleto,
          accion: 'Modificacion',
          panel: 'Gestion de Clientes',
          tabla: 'CONTACTOS',
          filaafectada: props.location.state.contactO_Id,
          UsuarioId: sesionUsuario.usuario.id,
        };
        RegistrarAccion(objetoAudi);
        volver();
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar guardar ',
          },
        });
      }
    });
  };
  const volver = () => {
    props.history.goBack();
  };

  useEffect(() => {
    if (mounted.current) {
      setId(contactop.contactO_Id);
      setContacto({
        NOMBRE: contactop.nombre,
        APELLIDO: contactop.apellido,
        TELEFONO: contactop.telefono,
        DIRECCION: contactop.direccion,
        EMAIL: contactop.email,
        OBSERVACIONES: contactop.observaciones,
        USUARIO: contactop.usuario,
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [contactop, id]);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <ContactMailIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Editar Contacto
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Modifica la información del contacto
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Información Principal */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Información del Contacto
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              name="NOMBRE"
              value={contacto.NOMBRE}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nombre"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="APELLIDO"
              value={contacto.APELLIDO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Apellido/Razón Social"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="TELEFONO"
              value={contacto.TELEFONO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Teléfono"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <PhoneIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="DIRECCION"
              value={contacto.DIRECCION}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Dirección"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <LocationOnIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="EMAIL"
              value={contacto.EMAIL}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Email"
              type="email"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <EmailIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="OBSERVACIONES"
              value={contacto.OBSERVACIONES}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              label="Observaciones"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'flex-start', pt: 1.5 }}>
                    <NotesIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Botones de acción */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volver}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-2px)',
              boxShadow: 2,
            },
            transition: 'all 0.2s ease',
          }}
        >
          Volver
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={EditarContacto}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Guardar Cambios
        </Button>
      </Box>
    </Container>
  );
};
export default PerfilContactos;
